import { DirectiveBinding, nextTick } from 'vue'

type InputRule = {
    allowNegative?: boolean // 是否允许负数
    allowDecimal?: boolean // 是否允许小数
    maxLength?: number // 最大长度
}

declare global {
    interface HTMLInputElement {
        _numberInputHandlers?: {
            compositionstart: EventListener;
            compositionend: EventListener;
            input: EventListener;
        };
    }
}

export const numberInputDirective = {
    mounted(el: HTMLInputElement, binding: DirectiveBinding<InputRule>) {
        let isComposing = false;

        const handleCompositionStart = () => {
            isComposing = true;
        };

        const handleCompositionEnd = (e: CompositionEvent) => {
            isComposing = false;
            // 手动触发输入事件处理
            handleInput(e as unknown as Event);
        };

        const handleInput = (e: Event) => {
            if (isComposing) return;

            const input = e.target as HTMLInputElement;
            const prevValue = input.value;
            const position = input.selectionStart;

            const { allowNegative = false, allowDecimal = false, maxLength } = binding.value || {}

            // 构建正则表达式
            let regex = allowDecimal ? /[^0-9.]/g : /[^0-9]/g
            if (allowNegative) regex = allowDecimal ? /[^-0-9.]/g : /[^-0-9]/g

            // 过滤非法字符
            let value = input.value.replace(regex, '')

            // 处理多个小数点
            if (allowDecimal) {
                const parts = value.split('.')
                if (parts.length > 2) {
                    value = parts[0] + '.' + parts.slice(1).join('')
                }
            }

            // 处理最大长度
            if (maxLength) {
                value = value.slice(0, maxLength)
            }

            input.value = value;

            if (input.value !== prevValue) {
                input.dispatchEvent(new Event('input'))
            }

            // 值未变化时保持光标位置
            if (input.value === prevValue && position !== null) {
                nextTick(() => {
                    input.setSelectionRange(position, position);
                });
            }
        };

        el.addEventListener('compositionstart', handleCompositionStart);
        el.addEventListener('compositionend', handleCompositionEnd);
        el.addEventListener('input', handleInput);

        // 保存事件处理器以便卸载
        el._numberInputHandlers = {
            compositionstart: handleCompositionStart,
            compositionend: handleCompositionEnd as any,
            input: handleInput
        };
    },

    beforeUnmount(el: HTMLInputElement) {
        if (el._numberInputHandlers) {
            el.removeEventListener('compositionstart', el._numberInputHandlers.compositionstart);
            el.removeEventListener('compositionend', el._numberInputHandlers.compositionend);
            el.removeEventListener('input', el._numberInputHandlers.input);
        }
    }
};